import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { LocaleService } from '@app/system/services/locale.service';
import { ApiService } from '../utilities/services/api.service';
import { DetectDeviceService } from '@app/system/services/detect-device.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { BaseService } from '@app/system/services/base.service';

@Component({
	selector: 'app-questions-detail',
	templateUrl: './questions-detail.component.html',
	styleUrls: ['./questions-detail.component.scss']
})
export class QuestionsDetailComponent implements OnInit, OnChanges {

	@Input() resourceDetail;
	@Input() closeQuestion = false;
	@Output() joined = new EventEmitter();
	@Output() loading = new EventEmitter<boolean>();

	showJoinInAsking = false;
	currentUser;
	submitButtonDisable = false;
	showCloseQuestion = true;
	deviceDetails;

	constructor(
		public locale: LocaleService,
		private apiService: ApiService,
		public gfService: GlobalFunctionService,
		public detectDevice: DetectDeviceService,
		private baseService: BaseService
	) {
		this.currentUser = this.gfService.sessionUser;
	}

	ngOnInit(): void {
		this.deviceDetails = this.detectDevice.fingerPrint;
	}

	ngOnChanges(changes) {
		if (changes) {
			if (changes.closeQuestion && changes.closeQuestion.currentValue) {
				this.submitCloseQuestion();
			}
		}
	}

	joinAsking() {
		if (navigator.onLine) {
			this.loading.emit(true);
			this.submitButtonDisable = true;
			const apiData = {};
			const headers: any = {};
			this.apiService.joinInAsking(apiData, this.resourceDetail.resourceID, headers).subscribe(
				(response) => {
					this.baseService.logUserActivity('joininasking', 'learning', [''], { resourceData: this.resourceDetail });
					this.joined.emit({ type: 'joined' });
					// this.showJoinInAsking = false;
					this.resourceDetail.resourceAction.joinInAsking = false;
					// this.resourceDetail.resourceAction.closeQuestion = true;
					this.gfService.openSnackBar('SUCCESS', {
						message: this.locale.translate('joined_in_asking'),
						icon: 'check_circle_outline',
						position: 'before'
					});
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					this.loading.emit(false);
					this.submitButtonDisable = false;
				});
		}
	}

	submitCloseQuestion() {
		if (navigator.onLine) {
			this.loading.emit(true);
			this.submitButtonDisable = true;
			const apiData = {
				notificationType: 1
			};

			if (this.deviceDetails.browserName === 'Safari') {
				apiData.notificationType = 2;
			}
			const headers: any = {};
			this.apiService.closeQuestion(apiData, this.resourceDetail.resourceID, headers).subscribe(
				(response) => {
					this.joined.emit({ type: 'closed' });
					if (this.resourceDetail.settings) {
						this.resourceDetail.settings.commenting = 'inactive';
					}
					this.showCloseQuestion = false;
					this.gfService.openSnackBar('SUCCESS', {
						message: this.locale.translate('question_closed_answers'),
						icon: 'check_circle_outline',
						position: 'before'
					});
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					this.loading.emit(false);
					this.submitButtonDisable = false;
				});
		}
	}

}
